import { render, staticRenderFns } from "./Mitig.vue?vue&type=template&id=a89d9328"
import script from "./Mitig.vue?vue&type=script&lang=js"
export * from "./Mitig.vue?vue&type=script&lang=js"
import style0 from "./Mitig.vue?vue&type=style&index=0&id=a89d9328&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports